import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleInfo, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { OutlineActionButton, ActionButtonBadge } from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
import {
  PurchaseStyles,
} from '../purchase/Purchase.styles';
import {
  ButtonSpinner,
  ConfirmCard,
  DocsCard,
  DocsFooter,
  Notice,
  Stack,
  SubmitDocsButton,
} from '../purchase/PurchaseV2.styles';
import InfoBoxSalute from '../../common/components/redesignComponents/Purchase/common/InfoBoxSalute';
import { SaveBox } from '../purchase/common/SaveBox';
import WaitingForPaymentStatusV2 from '../../common/components/redesignComponents/Purchase/WaitingForPaymentStatusV2';
import {
  purchaseInsuranceRequest,
  resetSalutePurchase,
  updateBrokerageSalute,
} from '../../features/purchases/purchasesActions';
import {
  confirmAlert,
  generalAlertError,
  generalAlertSuccess,
} from '../../common/utils/alerts';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
// import CompletedScreenSalute from './CompletedScreenSalute';
import CompletedScreen from '../../common/components/redesignComponents/Purchase/CompletedScreen';
import axe from '../../services/axios-client/axiosClient';
import BrokeraggioComponent from '../../common/components/redesignComponents/Purchase/BrokeraggioComponent';
import SentToCompanyAlert from '../purchase/SentToCompanyAlert';
import ModificaDatiComponent from '../../common/components/elements/ModificaDatiComponent';
import DocumentsResubmissionWarning from '../purchase/common/DocumentsResubmissionWarning';
import KoStatusAlert from '../purchase/KoStatusAlert';
import PendingIssuanceAlert from '../purchase/PendingIssuanceAlert';
import { purchase_statues } from '../../common/constants';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';

function PurchaseSaluteRequest() {
  const navigate = useNavigate();
  const { requestToken } = useParams();

  const state = useSelector((store) => store.purchases.salute);
  const [loadingDocuments, setLoadingDocuments] = useState(false);

  const {
    loading,
    quote,
    insuranceRequest,
    quoteStatus,
    // signMethod,
    backofficeUsers,
    rc_quotation,
    speseLegaliFamigliaQuote,
    incendioContenutoQuote,
    danniFamigliaConduzioneQuote,
    danniPropietarioQuote,
    incendioFabbricatoQuote,
    // signableDocs,
    // requestedOptionalDocumentsSignable,
    risk_quotations,
    thread,
  } = state;

  const navigateBack = () => {
    navigate(`/quotes/salute/${insuranceRequest.request_token}`);
  };
  const [showConversationModal, setShowConversationModal] = useState(false);

  const [supportMessage, setSupportMessage] = useState({
    subject: '',
    request_id: '',
    body: '',
    recipient: '',
  });

  const collectQuoteData = async () => {
    purchaseInsuranceRequest(requestToken, 'salute', setSupportMessage);
  };

  const silentRefresh = () => purchaseInsuranceRequest(requestToken, 'salute', setSupportMessage, navigate, false);

  const checkDocuments = async () => {
    try {
      if (
        insuranceRequest.documents.filter((doc) => doc.is_uploaded_valid == 0)
          .length > 0
      ) {
        generalAlertError('Elimina i documenti non validi prima di procedere!');
        return;
      }

      setLoadingDocuments(true);
      const response = await axe.post(
        `insurance-request/check-insurance-documents/${insuranceRequest.id}`,
      );

      if (
        response.status === 400
        && response.data?.data?.redirect_user === false
      ) {
        generalAlertError('Devi Caricare Tutti i Documenti Obbligatori!');
        setLoadingDocuments(false);
        return;
      }

      navigate('/');
      generalAlertSuccess('La pratica è completa, attendi nostro feedback!');
    } catch (error) {
      setLoadingDocuments(false);
      generalAlertError('Errore Interno');
    }
  };

  const agreedDocuments = async () => {
    try {
      const response = await axe.post(
        `/agree-to-upload-documents/${insuranceRequest.id}`,
        {
          agree_to_upload_document: 1,
        },
      );
      if (response.status !== 200) {
        generalAlertError('Non Accetato');
        return;
      }

      collectQuoteData();
    } catch (error) {
      //
    }
  };

  useEffect(() => {
    if (insuranceRequest && insuranceRequest.redirect_user === true) {
      navigate('/');
      generalAlertSuccess('La pratica è completa, attendi nostro feedback!');
    }
  }, [insuranceRequest]);

  // const continueWithoutSignDocs = () => {
  //   confirmAlert('Sei sicuro di voler firmare più tardi?', () => skipSignatureSalute(rc_quotation.id, navigate));
  // };

  // const continueWithSignDocs = () => {
  //   confirmAlert('Sei sicuro di voler firmare adesso?', () => continueWithSignatureSalute(rc_quotation.id, collectQuoteData));
  // };

  const sendBrokerageAmount = async (amount, skipCollect = false) => {
    if (skipCollect) {
      await updateBrokerageSalute(
        rc_quotation.id,
        amount,
        () => { },
        skipCollect,
      );
    } else {
      await updateBrokerageSalute(
        rc_quotation.id,
        amount,
        collectQuoteData,
        skipCollect,
      );
    }
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (rc_quotation !== null) {
      quoteInProccessAmount = parseFloat(rc_quotation.amount);
    }

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];

        risksTotalAmount += parseFloat(item.amount);
      }
    }

    const total = quoteInProccessAmount + risksTotalAmount;

    return total.toFixed(2);
  };

  useEffect(() => {
    collectQuoteData();

    return () => {
      resetSalutePurchase();
    };
  }, []);

  useEffect(() => {
    if (loading === false && insuranceRequest.is_expired === true && insuranceRequest.request_token === requestToken) {
      navigate('/quote/salute', {
        state: { requestToken: insuranceRequest.request_token },
      });
      generalAlertError(
        'È necessario compilare nuovamente il preventivo!',
        'Link e scaduto!',
      );
    }
  }, [loading, insuranceRequest, requestToken]);

  if (loading) {
    return <PageLoading />;
  }

  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_salute_purchase"
        />
      )}
      <PurchaseStyles>
        {quoteStatus !== 7 && (
          <>
            <div className="container mt-0 d-flex gap-2 align-items-center justify-content-start mb-3">
              {![4, 6, 7].includes(quoteStatus) && (
                <ModificaDatiComponent navigateBack={navigateBack} />
              )}
            </div>
            <div className="container mt-0">
              <InfoBoxSalute
                rc_quotation={rc_quotation}
                statuses={purchase_statues}
                insuranceRequest={insuranceRequest}
                quoteStatus={quoteStatus}
                messagesModalData={{
                  backofficeUsers,
                  setSupportMessage,
                  supportMessage,
                  collectData: collectQuoteData,
                }}
                risk_quotations={risk_quotations}
              />
              <div className="d-flex align-items-center justify-content-end mt-3">
                <OutlineActionButton
                  type="button"
                  onClick={() => {
                    setShowConversationModal(true);
                    if (thread?.unreadMessages > 0) silentRefresh();
                  }}
                >
                  <ChatIcon />
                  Contatta il Backoffice
                  {thread?.unreadMessages > 0 && (
                    <ActionButtonBadge>
                      {thread.unreadMessages}
                      <span className="visually-hidden">messaggi non letti</span>
                    </ActionButtonBadge>
                  )}
                </OutlineActionButton>
              </div>
              {quoteStatus === 1 || quoteStatus === 2 || quoteStatus === 5 ? (
                <Stack>
                  <SaveBox
                    insuranceRequest={insuranceRequest}
                    quotationId={rc_quotation.id}
                    refresh={collectQuoteData}
                  />

                  <ConfirmCard className="skip-doc" $done={insuranceRequest.agree_upload_documents === 1}>
                    <p>
                      <FontAwesomeIcon
                        icon={insuranceRequest.agree_upload_documents === 1 ? faCircleCheck : faTriangleExclamation}
                      />
                      Importante
                    </p>
                    <label>
                      <input
                        type="checkbox"
                        checked={insuranceRequest.agree_upload_documents === 1}
                        disabled={insuranceRequest.agree_upload_documents === 1}
                        onClick={() => confirmAlert('', () => agreedDocuments())}
                      />
                      Dichiaro di aver adempiuto agli obblighi in ambito di consegna documentazione precontrattuale
                    </label>
                  </ConfirmCard>

                  {insuranceRequest.agree_upload_documents !== null && (
                    <DocsCard>
                      <DocumentsResubmissionWarning quoteStatus={quoteStatus} />
                      {quoteStatus === 5 ? (
                        <Notice $tone="info" role="alert">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <p>Il nostro backoffice sta elaborando il preventivo.</p>
                        </Notice>
                      ) : (
                        <Notice $tone="info" role="alert">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <p>
                            Non è necessario caricare alcun documento. Premi
                            ‘Invia’ per continuare.
                          </p>
                        </Notice>
                      )}

                      {quoteStatus !== 5 && (
                        <DocsFooter>
                          <SubmitDocsButton
                            type="button"
                            onClick={() => confirmAlert(
                              'Sei sicuro di voler procedere?',
                              () => checkDocuments(),
                            )}
                            disabled={loadingDocuments}
                          >
                            {loadingDocuments && <ButtonSpinner />}
                            Invia
                          </SubmitDocsButton>
                        </DocsFooter>
                      )}
                    </DocsCard>
                  )}
                </Stack>
              ) : (
                ''
              )}

              {quoteStatus === 1 && (
                <BrokeraggioComponent
                  rc_quotation={rc_quotation}
                  sendBrokerageAmount={sendBrokerageAmount}
                  getTotal={getTotal}
                />
              )}

              {quoteStatus === 4 && (
                <WaitingForPaymentStatusV2
                  quote={quote}
                  rc_quotation={rc_quotation}
                  spese_legali_famiglia_quote={speseLegaliFamigliaQuote}
                  incendio_contenuto_quote={incendioContenutoQuote}
                  danni_famiglia_conduzione_quote={danniFamigliaConduzioneQuote}
                  danni_propietario_quote={danniPropietarioQuote}
                  incendio_fabbricato_quote={incendioFabbricatoQuote}
                  insuranceRequest={insuranceRequest}
                  collectQuoteData={collectQuoteData}
                  assistenza_quotation={null}
                  rivalsa_quotation={null}
                  infortuni_conducente_quotation={null}
                  cristalli_quotation={null}
                  risk_quotations={risk_quotations}
                />
              )}

              {quoteStatus === 6 && <PendingIssuanceAlert />}
              {/* {quoteStatus === 6 && (
                <div className="card-body mt-3">
                  <div className="row">
                    <div className="col-6 offset-3">
                      <div className="alert alert-success" role="alert">
                        <h4 className="alert-heading">In Attesa Emissione</h4>
                        <p>
                          Quando l'agente di backoffice carica la polizza,
                          riceverai una notifica e il contratto potrà essere
                          scaricato.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
              {quoteStatus === 8 && <SentToCompanyAlert />}
              {quoteStatus === 9 && <KoStatusAlert insuranceRequest={insuranceRequest} />}
            </div>
          </>
        )}
        {quoteStatus === 7 && (
          <>
            <div className="mt-0 gap-2 align-items-center justify-content-start mb-3">
              {/* <div>
                {localStorage.getItem('purchaseTour') === 'done' && (
                  <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                    <button className="btn btn-success px-2 py-1">Tutorial</button>
                  </div>
                )}
              </div> */}
            </div>

            {/* <CompletedScreenSalute
              risk_quotations={risk_quotations}
              quoteStatus={quoteStatus}
              customer={insuranceRequest.customer}
              rc_quotation={rc_quotation}
            /> */}
            <CompletedScreen
              product="salute"
              quoteStatus={quoteStatus}
              insuranceRequest={insuranceRequest}
              rc_quotation={rc_quotation}
              risk_quotations={risk_quotations}
            />
          </>
        )}
      </PurchaseStyles>
    </>
  );
}

export default PurchaseSaluteRequest;
